import React, { Fragment } from 'react';
import styles from './PromptSettings.module.scss';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import TextArea from 'component/atom/forms/text-area/TextArea';
import { useParams } from 'react-router-dom';
import { useFetch } from 'hooks/useFetch';
import { promptSettings } from 'hooks/endpoints';
import { useFormik } from 'formik';
import Loader from 'component/atom/loader/Loader';
import { usePost } from 'hooks/usePost';

const PromptSettings = () => {
  const { id } = useParams();
  const { mutate: submitSettings, isPending } = usePost({
    onErrorToast: 'Something we wrong',
  });

  const {
    data: botSettings,
    isFetching: isFetchingBotSettings,
    isLoading: isLoadingBotSettings,
    refetch: refetchBotSettings,
  } = useFetch(
    ['botSettings', id],
    promptSettings.getBotById,
    { enabled: true },
    { botId: id }
  );

  const {
    data: defaultSettings,
    isFetching: isFetchingDefaultSettings,
    isLoading: isLoadingDefaultSettings,
  } = useFetch(['defaultPromptSettings', id], promptSettings.getDefault, {
    enabled: true,
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      prompt1:
        botSettings?.data[0]?.prompt1 ?? defaultSettings?.data?.prompt1 ?? '',
      prompt2:
        botSettings?.data[0]?.prompt2 ?? defaultSettings?.data?.prompt2 ?? '',
      prompt3:
        botSettings?.data[0]?.prompt3 ?? defaultSettings?.data?.prompt3 ?? '',
    },
    onSubmit: (values) => {
      submitSettings(
        {
          url: promptSettings.createPromptSettings,
          data: { ...values, botId: id },
          requireAuth: true,
        },
        {
          onSuccess: () => {
            refetchBotSettings();
          },
        }
      );
    },
  });

  return (
    <div>
      <SettingsHeader
        title='Prompt Settings'
        rightButtons={[
          {
            label: 'Save',
            type: 'save',
            func: formik.handleSubmit,
            isLoading: isPending,
          },
        ]}
      />
      <div className={styles['inputs-container']}>
        {isFetchingBotSettings ||
        isFetchingDefaultSettings ||
        isLoadingBotSettings ||
        isLoadingDefaultSettings ? (
          <Loader />
        ) : (
          <Fragment>
            <TextArea
              label='Prompt 1'
              name='prompt1'
              value={formik.values.prompt1}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              wrapperClassName={styles['text-area-wrapper']}
              textAreaClassName={styles['text-area']}
              hasReset={true}
              onResetClick={() =>
                formik.setFieldValue(
                  'prompt1',
                  defaultSettings?.data?.prompt1 ?? ''
                )
              }
            />
            <TextArea
              label='Prompt 2'
              name='prompt2'
              value={formik.values.prompt2}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              wrapperClassName={styles['text-area-wrapper']}
              textAreaClassName={styles['text-area']}
              hasReset={true}
              onResetClick={() =>
                formik.setFieldValue(
                  'prompt2',
                  defaultSettings?.data?.prompt2 ?? ''
                )
              }
            />
            <TextArea
              label='Prompt 3'
              name='prompt3'
              value={formik.values.prompt3}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              wrapperClassName={styles['text-area-wrapper']}
              textAreaClassName={styles['text-area']}
              hasReset={true}
              onResetClick={() =>
                formik.setFieldValue(
                  'prompt3',
                  defaultSettings?.data?.prompt3 ?? ''
                )
              }
            />
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default PromptSettings;
